export default function () {
  return (-this.snapGrid[this.snapGrid.length - 1]);
}



// WEBPACK FOOTER //
// ../src/components/core/translate/maxTranslate.js